/* eslint-disable no-undef */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import {
//   createProvider
// } from "./vue-apollo";
import "normalize.css/normalize.css";
import "@/styles/index.scss"; // global css
import "element-ui/lib/theme-chalk/index.css";
// import Element from "element-ui";
import { Dialog,Tabs,TabPane,Pagination,Popover,Card,Timeline,TimelineItem,Collapse,CollapseItem,Tooltip,Button } from "element-ui";
Vue.use(Dialog);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Pagination);
Vue.use(Popover);
Vue.use(Card);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tooltip);
Vue.use(Button);
// import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import VueLazyload from "vue-lazyload";
import axios from "axios";
import Vcomp from "./views/pages/home/common/index";
Vue.config.productionTip = false;
import "./styles/fontstyle/iconfont.css"
import "./styles/iconfont.css"
/*全局引入*/
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css"; //这里注意具体看使用的版本是否需要引入样式，以及具体位置。
Vue.use(VueAwesomeSwiper);
// 图片放大
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import "./styles/font.css";
import track from "./utils/common";
import {strToArr} from '@/utils/strToArr';

Vue.use(track);
Vue.use(Vcomp);
Vue.prototype.strToArr = strToArr
Vue.prototype.$axios = axios;
// Vue.use(Viewer)
// Viewer.setDefaults({
//   Options: {
//   'inline':false,
//   'button':true, //右上角按钮
//   "navbar": false, //底部缩略图
//   "title": false, //当前图片标题
//   "toolbar": false, //底部工具栏
//   "tooltip": false, //显示缩放百分比
//   "movable": false, //是否可以移动
//   "zoomable": false, //是否可以缩放
//   "rotatable": false, //是否可旋转
//   "scalable": false, //是否可翻转
//   "transition": false, //使用 CSS3 过度
//   "fullscreen": false, //播放时是否全屏
//   "keyboard": false, //是否支持键盘
//   "url": "data-source"
// }
// })
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
import eventLog from './utils/directive/eventLog.js'
Vue.use(eventLog)

Vue.use(Viewer, {
  defaultOptions: {
    inline: false,
    button: true, //右上角按钮
    navbar: true, //底部缩略图
    title: false, //当前图片标题
    toolbar: true,
    tooltip: true, //显示缩放百分比
    movable: true, //是否可以移动
    zoomable: true, //是否可以缩放
    rotatable: false, //是否可旋转
    scalable: false, //是否可翻转
    transition: true, //使用 CSS3 过度
    fullscreen: true, //播放时是否全屏
    keyboard: true, //是否支持键盘
    url: "data-original",
  },
});
Vue.use(VueLazyload);
// Element

// Vue.use(Element, {
//   locale
// });
// Vue.prototype.$message = Message
// sentry
// import * as Sentry from "@sentry/browser";
// import * as Integrations from "@sentry/integrations";
// if (process.env.NODE_ENV === "production") {
//   Sentry.init({
//     dsn: "https://ae706dbae7ca4186b29d9ffade8d0cdf@sentry.itheima.net/2",
//     integrations: [new Integrations.Vue({
//       Vue,
//       attachProps: true
//     })],
//   });
// }

// echarts
// import * as echarts from 'echarts'
// Vue.prototype.$echarts = echarts

/*
cnzz 监控

function(category, action, label, value, nodeid) {}

category：事件类别，必填项，表示事件发生在谁身上，如“视频”、“小说”、“轮显层”等等。
action：事件操作，必填项，表示访客跟元素交互的行为动作，如"播放"、"收藏"、"翻层"等等。
label：事件标签，选填项，用于更详细的描述事件，从各个方面都可以，比如具体是哪个视频，哪部小说，翻到了第几层等等。
value：事件值，选填项，整数型，用于填写打分型事件的分值，加载时间型事件的时长，订单型事件的价格等等。
nodeid：div元素id，选填项，填写网页中的div元素id值，用于在“用户视点”功能上重绘元素的事件发生情况。

示例

  mounted() {
    this.$trackEvent('页面导航','载入完成','Java首页')
  },

*/
Vue.prototype.$trackEvent = function (category, action, label, value, nodeid) {
  try {
    if (_czc !== undefined) {
      _czc.push(["_trackEvent", category, action, label, value, nodeid]);
    }
  } catch (error) {
    console.log("_czc", error);
  }
}; 

new Vue({
  router,
  store,
  // apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount("#app");